import type { StreamingCommand, StreamableCommand } from '../../aiStreamingOrchestratorPluginType';

/**
 * Checks if a command is streamable.
 * @param command - The command to check.
 * @returns True if the command is streamable, false otherwise.
 */
export function isAStreamableCommand(command: StreamingCommand): command is StreamableCommand {
	return [
		'replaceNode',
		'insertNodeBefore',
		'insertNodeAfter',
		'appendNode',
		'appendNodeToEnd',
	].includes(command.type);
}
